/**
 * @file 课程学习证书弹出时通知服务端
 * @author liudy
 * @see http://api.umucdn.cn/project/111/interface/api/1361
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export enum CERTIFICAT_DIALOG_TYPE {
    COURSE = 1,
}

export interface IShowCertificateDialogInput {
    obj_id: number; // int 对应id
    obj_type: number;
}

export interface IShowCertificateDialogOutput {
    status: number;
}

// tslint:disable-next-line:max-line-length
export const showCertificateDialog = (
    data: IShowCertificateDialogInput,
): Promise<IResponse<IShowCertificateDialogOutput>> => {
    return fetchData(Api.COURSE_SHOW_CERTIFICATE_DIALOG, data);
};
